module.exports = __webpack_public_path__ + "img/user.41cbcea2.svg";